import { jsxs as k, jsx as n } from "react/jsx-runtime";
import { c as E } from "./index-65016bfa.mjs";
import { useRef as q } from "react";
import d, { css as l } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as M } from "./useQuantum-50e8fd44.mjs";
import { b as U } from "./Aria-f5e019e2.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Icon as z } from "./icon.js";
import { I as a, H as A } from "./helperText-d9646f54.mjs";
import { L as Q } from "./label-33699561.mjs";
import { u as X } from "./uniqueId-321287e8.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "@fcamna/shared-icons";
import "./popupTip.js";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
const G = "Progressbar", J = d.div`
  &.Progressbar {
    ${({
  theme: {
    components: { progressBar: s }
  }
}) => l(s.MainWrapper)};
  }
`, K = d(z)`
  &.LabelIcon {
    ${({
  theme: {
    components: { progressBar: s }
  }
}) => l(s.LabelIcon)};
  }
`, Y = d.div`
  &.Progressbar__container {
    ${({
  theme: {
    components: { progressBar: s }
  }
}) => l(s.ProgressBarContainer)};
  }
`, Z = d.div`
  &.Progressbar__content {
    ${({
  theme: {
    components: { progressBar: s }
  },
  $progressWidth: i
}) => `
      ${l(s.ProgressBarContent).join("")}
      width: ${i}
    `};
  }
`;
function Br({
  helperText: s,
  progressValue: i = 0,
  maxValue: f = 100,
  status: o = "default",
  labelProp: c,
  infoProp: L,
  trailingText: N,
  accessibilityOptions: v = {},
  style: B,
  helperTextProp: m,
  ...C
}) {
  var b, I, y, $, R, P, S;
  const _ = M({ label: "Progress Bar" }), u = q(X(C.id ?? G)), g = `${u.current}_label_id`;
  function O(W) {
    switch (W) {
      case a.ERROR:
        return a.ERROR;
      case a.SUCCESS:
        return a.SUCCESS;
      default:
        return a.NONE;
    }
  }
  let r = m;
  const e = O(o);
  m ? r = {
    ...m,
    secondaryProp: {
      ...m.secondaryProp,
      state: e
    }
  } : r = {
    [e === a.ERROR ? "secondaryProp" : "defaultProp"]: {
      helperText: s,
      id: `${e === a.ERROR ? "invalid" : "valid"}_helperText`,
      state: e
    }
  };
  const t = {
    defaultId: ((b = r == null ? void 0 : r.defaultProp) == null ? void 0 : b.id) || `default_${u.current}_message_id`,
    secondaryId: ((I = r == null ? void 0 : r.secondaryProp) == null ? void 0 : I.id) || `secondary_${u.current}_message_id`
  }, w = !!(($ = (y = r == null ? void 0 : r.defaultProp) == null ? void 0 : y.helperText) != null && $.trim().length), D = !!((P = (R = r == null ? void 0 : r.secondaryProp) == null ? void 0 : R.helperText) != null && P.trim().length) && ((S = r == null ? void 0 : r.secondaryProp) == null ? void 0 : S.state) !== a.NONE;
  let p = c != null && c.label ? g : "";
  w && (p += ` ${t == null ? void 0 : t.defaultId}`), D && (p += ` ${t == null ? void 0 : t.secondaryId}`);
  const j = U(
    "progressbar",
    {
      ...v,
      ariaValuemax: f,
      ariaValuenow: i,
      ariaLabelledby: p,
      ariaLive: "polite"
    }
  ), F = o === "default", H = i > f || !F ? "100%" : `${i * 100 / f}%`;
  return /* @__PURE__ */ k(
    J,
    {
      style: B,
      className: "Progressbar",
      ..._,
      children: [
        /* @__PURE__ */ n(
          Q,
          {
            labelProp: {
              id: g,
              ...c
            },
            infoProp: {
              infoText: "",
              infoType: "tooltip",
              popupTipHeader: "Info",
              ...L
            },
            trailingText: o === "default" ? N : "",
            trailingElement: o === "success" || o === "error" ? /* @__PURE__ */ n(
              K,
              {
                className: E(["LabelIcon", `LabelIcon--${o}`]),
                "aria-label": o === "success" ? "success" : "error",
                size: "s",
                name: o === "success" ? "checkmarkFilled" : o === "error" ? "warningFilled" : void 0
              }
            ) : void 0
          }
        ),
        /* @__PURE__ */ n(Y, { className: "Progressbar__container", children: /* @__PURE__ */ n(
          Z,
          {
            ...j,
            className: E(["Progressbar__content", `Progressbar__content--${o}`]),
            tabIndex: 0,
            $progressWidth: H
          }
        ) }),
        r && /* @__PURE__ */ n(
          A,
          {
            secondaryProp: {
              id: t.secondaryId,
              ...r == null ? void 0 : r.secondaryProp,
              state: e
            },
            defaultProp: { id: t.defaultId, ...r == null ? void 0 : r.defaultProp }
          }
        )
      ]
    }
  );
}
export {
  Br as ProgressBar
};
